import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { SortBot } from '../../../app/helpers/sort';
import { Router } from '@angular/router';

import { GlobalAddressWhitelistBasic, GlobalAddressWhitelistBasicArray } from '@models/ss-api/responses/global.address.whitelist.basic';
import { AddGlobalAddressWhitelist } from 'app/dialogs/add.global.address.whitelist.dialog/add.global.address.whitelist.dialog';

@Component({
    selector: 'tos-address-whitelist',
    templateUrl: './tos.address.whitelist.component.html',
    styleUrls: ['./tos.address.whitelist.component.scss']
})

export class TOSAddressWhitelistComponent implements OnInit {
    IsBusy: boolean = false;

    GlobalAddressWhitelists: GlobalAddressWhitelistBasicArray;
    AddressFilter: string;

    constructor(private dialogService: DialogService,
        private api: ssApiService,
        private gb: GlobalService,
        private sweetAlert: SweetAlertService,
        private router: Router) { }

    ngOnInit() {
        this.gb.SetPageTitle('TOS Address Whitelist');

        this.GetAddresses();
    }

    sortBy(sortVar1, sortVar2?) {
        this.GlobalAddressWhitelists = SortBot.SortAuto(this.GlobalAddressWhitelists, sortVar1, sortVar2);
    }

    GetAddresses() {
        this.IsBusy = true;
        let disposable = this.api.GetGlobalAddressWhitelists().subscribe((response) => {
            if (response.Result) {
                this.GlobalAddressWhitelists = response.Data;
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Error Loading Items',
                    text: response.Message
                }).then(() => { }, () => { });
            }
            this.IsBusy = false;
            disposable.unsubscribe();
        });
    }

    DeleteItem(item: GlobalAddressWhitelistBasic) {

        this.IsBusy = true;

        this.sweetAlert.swal({
            type: 'warning',
            title: 'Are you sure?',
            text: 'The address will no longer be whitelisted - tickets may be generated',
            showCancelButton: true
        }).then((response) => {
            this.IsBusy = false;
            let disposable = this.api.RemoveGlobalAddressWhitelist(item.ID).subscribe(response => {
                if (response.Result) {
                    this.sweetAlert.swal({
                        type: 'success',
                        title: 'Address Removed',
                        timer: 1500
                    }).then(() => { }, () => { });
                    this.GetAddresses();
                } else {
                    this.sweetAlert.swal({
                        type: 'error',
                        title: 'Error',
                        text: response.Message
                    }).then(() => { }, () => { });
                }
                disposable.unsubscribe();
            });
        }, (dismiss) => {
            this.IsBusy = false;
        });

    }

    AddItem() {
        let disposable = this.dialogService.addDialog(AddGlobalAddressWhitelist, {
            Title: 'Add Global Address TOS Whitelist',
            IsEditDialog: false
        }, { width: 800, height: 600 }).subscribe(response => {
            disposable.unsubscribe();
            if (response) {
                this.GetAddresses();
            }
        });
    }

    EditItem(item: GlobalAddressWhitelistBasic) {
        let disposable = this.dialogService.addDialog(AddGlobalAddressWhitelist, {
            Title: 'Edit Global Address TOS Whitelist',
            IsEditDialog: true,
            Item: item
        }, { width: 800, height: 600 }).subscribe(response => {
            disposable.unsubscribe();
            if (response) {
                this.GetAddresses();
            }
        });
    }

}
